import { Routes } from '@angular/router';
import { authGuard, SPECTRUM_HELP_ROUTES } from 'common';

export const routes: Routes = [
    {
        path: 'validate',
        loadComponent: () => import('./validate/validate.component').then(m => m.ValidateComponent)
    },
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('./layout/screens.component').then(m => m.ScreensComponent),
        children: [
            // The Help centre: this module's manual and Getting around Spectrum.
            ...SPECTRUM_HELP_ROUTES,
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard',
                loadComponent: () => import('./screens/dashboard/dashboard.component').then(m => m.DashboardComponent)
            },
            {
                path: 'mark-attendance',
                loadComponent: () => import('./screens/mark-attendance/mark-attendance.component').then(m => m.MarkAttendanceComponent)
            },
            {
                path: 'staff-attendance',
                loadComponent: () => import('./screens/staff-attendance/staff-attendance.component').then(m => m.StaffAttendanceComponent)
            },
            {
                path: 'period-matrix',
                loadComponent: () => import('./screens/period-matrix/period-matrix.component').then(m => m.PeriodMatrixComponent)
            },
            {
                path: 'early-warning',
                loadComponent: () => import('./screens/early-warning/early-warning.component').then(m => m.EarlyWarningComponent)
            },
            {
                path: 'leave',
                loadComponent: () => import('./screens/leave/leave.component').then(m => m.LeaveComponent)
            },
            {
                path: 'compliance',
                loadComponent: () => import('./screens/compliance/compliance.component').then(m => m.ComplianceComponent)
            },
            {
                path: 'reports',
                loadComponent: () => import('./screens/reports/reports.component').then(m => m.ReportsComponent)
            },
            {
                path: 'devices',
                loadComponent: () => import('./screens/devices/devices.component').then(m => m.DevicesComponent)
            },
            {
                path: 'settings',
                loadComponent: () => import('./screens/settings/settings.component').then(m => m.SettingsComponent)
            },
        ]
    },
    { path: '**', redirectTo: '' }
];
